export const productUrls: Record<string, Record<string, string>> = {
  dev: {
    evo: "https://evo.dev.connect-nonprod.sportradar.dev",
    video_stream_manager: "https://vm.dev.connect-nonprod.sportradar.dev",
    competition_manager: "https://competitions.dev.connect-nonprod.sportradar.dev",
    ingame: "https://stats.dev.connect-nonprod.sportradar.dev",
    internal_tools: "https://dc-internal-tools.dev.connect-nonprod.sportradar.online",
    user_manager: "https://uman.dev.connect-nonprod.sportradar.dev",
    live_production_monitor: "https://pm.dev.connect-nonprod.sportradar.dev",
    web: "https://admin.eui.dev.connect-nonprod.sportradar.dev",
  },
  stg: {
    evo: "https://evo.stg.connect-nonprod.sportradar.dev",
    video_stream_manager: "https://vm.stg.connect-nonprod.sportradar.dev",
    competition_manager: "https://competitions.stg.connect-nonprod.sportradar.dev",
    ingame: "https://stats.stg.connect-nonprod.sportradar.dev",
    internal_tools: "https://dc-internal-tools.dev.connect-nonprod.sportradar.online/",
    user_manager: "https://uman.stg.connect-nonprod.sportradar.dev/",
    live_production_monitor: "https://pm.stg.connect-nonprod.sportradar.dev",
    web: "https://admin.eui.stg.connect-nonprod.sportradar.dev",
  },
  prod: {
    evo: "https://evo.prod.connect.sportradar.com",
    video_stream_manager: "https://vm.prod.connect.sportradar.com",
    competition_manager: "https://competitions.connect.sportradar.com",
    ingame: "https://stats.connect.sportradar.com",
    internal_tools: "https://dc-internal-tools.connect.sportradar.online/",
    user_manager: "https://uman.connect.sportradar.com/",
    live_production_monitor: "https://pm.prod.connect.sportradar.com",
    web: "https://admin.eui.connect.sportradar.com",
  },
  sandpit: {
    evo: "https://evo.dev.connect-nonprod.sportradar.dev",
    video_stream_manager: "https://vm.dev.connect-nonprod.sportradar.dev",
    competition_manager: "https://competitions.dev.connect-nonprod.sportradar.dev",
    ingame: "https://stats.dev.connect-nonprod.sportradar.dev",
    internal_tools: "https://dc-internal-tools.dev.connect-nonprod.sportradar.online",
    user_manager: "https://uman.dev.connect-nonprod.sportradar.dev",
    live_production_monitor: "https://pm.dev.connect-nonprod.sportradar.dev",
    web: "https://admin.eui.dev.connect-nonprod.sportradar.dev",
  },
  feat: {
    evo: "https://evo.dev.connect-nonprod.sportradar.dev",
    video_stream_manager: "https://vm.dev.connect-nonprod.sportradar.dev",
    competition_manager: "https://competitions.dev.connect-nonprod.sportradar.dev",
    ingame: "https://stats.dev.connect-nonprod.sportradar.dev",
    internal_tools: "https://dc-internal-tools.dev.connect-nonprod.sportradar.online",
    user_manager: "https://uman.dev.connect-nonprod.sportradar.dev",
    live_production_monitor: "https://pm.dev.connect-nonprod.sportradar.dev",
    web: "https://admin.eui.dev.connect-nonprod.sportradar.dev",
  },
  ci: {
    evo: "https://evo.dev.connect-nonprod.sportradar.dev",
    video_stream_manager: "https://vm.dev.connect-nonprod.sportradar.dev",
    competition_manager: "https://competitions.dev.connect-nonprod.sportradar.dev",
    ingame: "https://stats.dev.connect-nonprod.sportradar.dev",
    internal_tools: "https://dc-internal-tools.dev.connect-nonprod.sportradar.online",
    user_manager: "https://uman.dev.connect-nonprod.sportradar.dev",
    live_production_monitor: "https://pm.dev.connect-nonprod.sportradar.dev",
    web: "https://admin.eui.dev.connect-nonprod.sportradar.dev",
  },
  local: {
    evo: "https://evo.dev.connect-nonprod.sportradar.dev",
    video_stream_manager: "https://vm.dev.connect-nonprod.sportradar.dev",
    competition_manager: "https://competitions.dev.connect-nonprod.sportradar.dev",
    ingame: "https://stats.dev.connect-nonprod.sportradar.dev",
    internal_tools: "https://dc-internal-tools.dev.connect-nonprod.sportradar.online",
    user_manager: "https://uman.dev.connect-nonprod.sportradar.dev",
    live_production_monitor: "https://pm.dev.connect-nonprod.sportradar.dev",
    web: "https://admin.eui.dev.connect-nonprod.sportradar.dev",
  },
} as const;
